import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthService } from './auth.service';

/**
 * Force-password-change guard (ADR-0081).
 *
 * Redirects any authenticated user with ``force_password_change=true``
 * to ``/me/force-change-password`` until they rotate their password.
 *
 * Whitelist:
 *  - The force-change page itself (or it's an infinite redirect).
 *  - ``/login`` and ``/logout`` so the user can escape if they realise
 *    they're signed in as the wrong person.
 *
 * The guard is wired as a top-level ``canActivateChild`` on the
 * authenticated route subtree.
 */
export const forcePasswordChangeGuard: CanActivateFn = (_route, state): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = auth.user();
  if (!user || !user.forcePasswordChange) return true;

  const safe =
    state.url.startsWith('/me/force-change-password') ||
    state.url.startsWith('/login') ||
    state.url.startsWith('/logout');
  if (safe) return true;

  return router.createUrlTree(['/me/force-change-password']);
};
